/* ═══════════════════════════════════════════════════════════════
   gb-clothes-rail.js: "A Little Christmas" hanger rail on the HOMEPAGE
   (live since 2026-10-24; demo history in the journal, 2026-10-23/24).
   It replaced the green "A Little Christmas" banner (owner, 2026-10-24).
   The homepage writes only the heading (badges, title, text) and the "Shop the
   Collection" button inside <section id="gb-clothes-rail" data-img="…">, in
   English/Arabic from its own t_xmas_* texts. This script builds the rest: the snow,
   the rail, the six cut-out pieces on branded wooden hangers, the close-up, sizes
   and Add to cart.
   - Names, prices, sizes and availability come live from the collection.
   - Stock numbers come from /products/<handle>?view=gb-stock (same as the cart).
   - The cut-out photos are Shopify Files: gb-rail-<handle>.webp (rail) and
     gb-rail-<handle>-detail.webp (close-up). A new Christmas product needs
     its own two cut-outs + one line in CUTS below, otherwise it isn't shown.
   - Add to cart uses the shared cart (window.GBCart from gb-cart.js, loaded first).
   Interaction ideas adapted from the Virtual Store Build Guide by Bildyard (@adexbuilds).
   ═══════════════════════════════════════════════════════════════ */
(function(){
  var root = document.getElementById("gb-clothes-rail");
  if (!root) return;

  var AR = /^ar/i.test(document.documentElement.lang || "") || /^\/ar(\/|$)/.test(location.pathname);
  /* the local preview runs on localhost: products from the live store, photos from the local folder */
  var LOCAL = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  var STORE = LOCAL ? "https://gagaberry.com" : "";
  var IMG = LOCAL ? "clothes-rail/upload/" : (root.getAttribute("data-img") || "");
  var LOGO = root.getAttribute("data-logo") || "";
  var HANDLE = root.getAttribute("data-collection") || "a-little-christmas";
  var LIMIT = Math.max(1, Math.min(12, +root.getAttribute("data-limit") || 6));
  var ALL_URL = STORE + (AR ? "/ar" : "") + "/pages/a-little-christmas";
  var REDUCED = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var touch = window.matchMedia && matchMedia("(hover: none)").matches;
  var ASSET_VERSION = "1";   /* bump when a cut-out photo is replaced (browsers keep old copies) */

  /* The six cut-outs. w/h = size of the original cut-out; neckX/neckY = where the collar sits
     (fractions of the photo); hanger = hanger width (fraction of the piece); cropBottom = rail shows
     only the top part (the cardigan of a two-piece set). Measured by hand, don't guess new ones. */
  var CUTS = [
    { handle: "ruby-snowdrop-knit-baby-cardigan", w: 1374, h: 1145, neckX: .493, neckY: .17, hanger: .5,
      en: "Ruby Snowdrop", ar: "روبي سنودروب", d_en: "Knit cardigan", d_ar: "كارديغان محبوك" },
    { handle: "merry-blossom-knit-cardigan-bloomer-set", w: 1086, h: 1448, neckX: .5, neckY: .11, hanger: .5,
      en: "Merry Blossom Set", ar: "طقم ميري بلوسوم", d_en: "Cardigan + bloomer", d_ar: "كارديغان وبلومر" },
    { handle: "cream-little-house-knit-baby-cardigan", w: 1230, h: 1278, neckX: .5, neckY: .245, hanger: .5,
      en: "Little House", ar: "البيت الصغير", d_en: "Knit cardigan", d_ar: "كارديغان محبوك" },
    { handle: "ivory-embroidered-baby-sleepsuit", w: 1086, h: 1448, neckX: .505, neckY: .095, hanger: .5,
      en: "Ivory Embroidered", ar: "أوفرول مطرّز عاجي", d_en: "Knitted sleepsuit", d_ar: "أوفرول محبوك" },
    { handle: "red-christmas-print-baby-romper", w: 1122, h: 1402, neckX: .49, neckY: .085, hanger: .5,
      en: "Christmas Red", ar: "رومبر الكريسماس الأحمر", d_en: "Knitted romper", d_ar: "رومبر محبوك" },
    { handle: "cream-pink-reindeer-baby-romper-with-matching-hat", w: 1086, h: 1448, neckX: .56, neckY: .16, hanger: .5,
      en: "Little Reindeer", ar: "الرنّة الصغيرة", d_en: "Romper + matching hat", d_ar: "رومبر وقبعة متناسقة" }
  ];
  function railSrc(c){ return IMG + "gb-rail-" + c.handle + ".webp?v=" + ASSET_VERSION; }
  function detailSrc(c){ return IMG + "gb-rail-" + c.handle + "-detail.webp?v=" + ASSET_VERSION; }

  var T = AR ? {
    title: "لمسة من الكريسماس",
    count: "{n} قطع على الرف",
    rail_label: "تشكيلة الكريسماس المعلّقة", photo: "الصورة الأصلية", rail_view: "العودة إلى القطعة المعلّقة",
    photos: "صور القطعة", photo_n: "الصورة {n}",
    explore: "كيف تتسوّقين؟",
    explore_help: "مرّري المؤشر على الرف واضغطي على قطعة لتشاهديها عن قرب، ثم اختاري المقاس وأضيفيها إلى السلة. استخدمي الأسهم للتنقّل بين القطع، و«الصورة الأصلية» لرؤية تفاصيل القطعة.",
    explore_touch: "اسحبي على طول الرف واضغطي على أي قطعة لتشاهديها عن قرب، ثم اختاري المقاس وأضيفيها إلى السلة. اسحبي يميناً أو يساراً للتنقّل بين القطع.",
    prev: "السابق", next: "التالي", close: "إغلاق", size: "المقاس",
    add: "أضيفي إلى السلة", added: "✓ في السلة · عرض السلة",
    choose: "اختاري المقاس أولاً", one_size: "المقاس: {s}",
    sold: "نفدت الكمية", months: "أشهر",
    all_in: "كل القطع المتوفرة في سلتكِ",
    open: "{name}، {price}. اضغطي لتشاهدي التفاصيل",
    cart_cat: "لمسة من الكريسماس",
    price: function(p){ return fmtNum(p) + " درهم"; },
    ticker: ["قطع صغيرة لموسم الأعياد", "توصيل مجاني في الإمارات من 200 درهم", "التوصيل خلال 2–3 أيام عمل", "ادفعي إلكترونياً أو عند الاستلام"]
  } : {
    title: "A Little Christmas",
    count: "{n} pieces on the rail",
    rail_label: "Christmas pieces on the rail", photo: "Original photo", rail_view: "Back to hanging view",
    photos: "Product photos", photo_n: "Photo {n}",
    explore: "How to explore",
    explore_help: "Move along the rail and click a piece for a closer look, then choose a size and add it to your cart. Use the arrows (or arrow keys) to move between pieces, and Original photo to see every detail.",
    explore_touch: "Swipe along the rail and tap a piece for a closer look, then choose a size and add it to your cart. Swipe left or right to move between pieces.",
    prev: "Previous", next: "Next", close: "Close", size: "Size",
    add: "Add to cart", added: "✓ In your cart · View cart",
    choose: "Choose a size first", one_size: "Size: {s}",
    sold: "Sold out", months: "months",
    all_in: "All the pieces in stock are in your cart",
    open: "{name}, {price}. Open close-up",
    cart_cat: "A Little Christmas",
    price: function(p){ return "AED " + fmtNum(p); },
    ticker: ["Little festive favourites", "Free UAE delivery from AED 200", "Delivered in 2–3 working days", "Pay online or cash on delivery"]
  };

  function fmtNum(p){ p = +p; return p % 1 ? p.toFixed(2) : String(p); }
  function esc(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){ return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function img(src, w){ return src ? src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + w : ""; }
  function $(sel){ return root.querySelector(sel); }
  /* "0-3months", "3-6 months" → { a: "3–6", b: "months" }; ⁦…⁩ keeps "3–6" in order inside Arabic text */
  function sizeParts(s){
    var m = /(\d+)\s*[-–]\s*(\d+)\s*m/i.exec(s || "");
    return m ? { a: m[1] + "–" + m[2], b: T.months, full: "⁦" + m[1] + "–" + m[2] + "⁩ " + T.months } : { a: s || "", b: "", full: s || "" };
  }

  /* ── the markup (kept out of the homepage, which is close to Shopify's size limit) ── */
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M12 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* the heading and the button come from the homepage (its own EN/AR texts); a plain title if they are missing */
  var head = root.querySelector(".gbr-head"), foot = root.querySelector(".gbr-foot");
  if (!head) { head = document.createElement("header"); head.className = "gbr-head"; head.innerHTML = '<h2 class="gbr-title" id="gbr-title">' + esc(T.title) + "</h2>"; }
  head.insertAdjacentHTML("beforeend", '<details class="gbr-help"><summary>' + esc(T.explore) + '</summary><p>' + esc(touch ? T.explore_touch : T.explore_help) + "</p></details>");
  var snow = ""; for (var f = 0; f < 14; f++) snow += "<span></span>";
  root.setAttribute("aria-labelledby", "gbr-title");
  root.innerHTML =
      '<div class="gbr-card"><div class="gbr-snow" aria-hidden="true">' + snow + "</div>"
    + '<div class="gbr-stage">'
    /* the rod stays put across the box (both brackets always visible); only the clothes slide under it */
    +   '<span class="gbr-rod" aria-hidden="true"><span class="gbr-bracket gbr-bracket-a"></span><span class="gbr-bracket gbr-bracket-b"></span></span>'
    +   '<div class="gbr-scroll" role="region" aria-label="' + esc(T.rail_label) + '" tabindex="0"><div class="gbr-track">'
    +     '<ul class="gbr-items"></ul></div></div>'
    +   '<div class="gbr-under">'
    +     '<div class="gbr-browse"><button type="button" class="gbr-rail-prev" aria-label="' + esc(T.prev) + '">' + ARROW + '</button><span class="gbr-count" aria-live="polite"></span><button type="button" class="gbr-rail-next" aria-label="' + esc(T.next) + '">' + ARROW + '</button></div>'
    +   '</div>'
    +   '<div class="gbr-focus" hidden role="dialog" aria-labelledby="gbr-focus-name">'
    +     '<button type="button" class="gbr-close" aria-label="' + esc(T.close) + '">✕</button>'
    +     '<button type="button" class="gbr-nav gbr-nav-prev" aria-label="' + esc(T.prev) + '">' + ARROW + '</button>'
    +     '<div class="gbr-focus-main">'
    +       '<div class="gbr-focus-hang"><span class="gbr-piece gbr-focus-piece"><span class="gbr-hanger" aria-hidden="true"></span><img class="gbr-focus-img" alt=""></span>'
    +         '<span class="gbr-sizes" role="group" aria-label="' + esc(T.size) + '"></span></div>'
    +       '<div class="gbr-photo-view" hidden><img class="gbr-photo-img" alt=""></div>'
    +       '<div class="gbr-focus-info">'
    +         '<p class="gbr-position" dir="ltr"></p>'
    +         '<h3 class="gbr-focus-name" id="gbr-focus-name" tabindex="-1">&nbsp;</h3>'
    +         '<p class="gbr-focus-price">&nbsp;</p>'
    +         '<p class="gbr-detail"></p>'
    +         '<button type="button" class="gbr-photo-btn" aria-pressed="false">' + esc(T.photo) + '</button>'
    +         '<div class="gbr-photo-thumbs" role="group" aria-label="' + esc(T.photos) + '" hidden></div>'
    +         '<button type="button" class="gbr-add">' + esc(T.add) + '</button>'
    +         '<p class="gbr-hint" aria-live="polite">&nbsp;</p>'
    +       '</div>'
    +     '</div>'
    +     '<button type="button" class="gbr-nav gbr-nav-next" aria-label="' + esc(T.next) + '">' + ARROW + '</button>'
    +   '</div>'
    + '</div>'
    + '<div class="gbr-ticker" aria-hidden="true"><span class="gbr-ticker-run"></span></div>'
    + '</div>';
  var card = root.querySelector(".gbr-card");
  card.insertBefore(head, card.querySelector(".gbr-stage"));
  if (foot) card.insertBefore(foot, card.querySelector(".gbr-ticker"));

  var ui = {
    stage: $(".gbr-stage"), scroll: $(".gbr-scroll"), track: $(".gbr-track"), list: $(".gbr-items"), under: $(".gbr-under"),
    focus: $(".gbr-focus"), main: $(".gbr-focus-main"),
    piece: $(".gbr-focus-piece"), fImg: $(".gbr-focus-img"), sizes: $(".gbr-sizes"),
    name: $(".gbr-focus-name"), price: $(".gbr-focus-price"), add: $(".gbr-add"), hint: $(".gbr-hint"), hang: $(".gbr-focus-hang"),
    photo: $(".gbr-photo-view"), photoImg: $(".gbr-photo-img"), photoBtn: $(".gbr-photo-btn"), thumbs: $(".gbr-photo-thumbs"),
    detail: $(".gbr-detail"), position: $(".gbr-position")
  };
  var items = [], cur = -1, chosen = null, dragMoved = false;
  var flight = null, closing = false, stock = {};
  var hangerLogo = LOGO ? '<img class="gbr-hanger-logo" src="' + esc(img(LOGO, 160)) + '" alt="" width="160" height="80" draggable="false">' : "";
  ui.piece.querySelector(".gbr-hanger").innerHTML = hangerLogo;

  /* Puts the photo so its collar sits on the hanger (measured anchors, see CUTS). */
  function placement(c, rail){
    var r = c.h / c.w;
    var height = Math.max(.49 + .9 * r * (1 - c.neckY), 1.10);
    var x = .5 - .9 * c.neckX, y = .43 - c.neckY * .9 * r;
    if (rail && c.cropBottom) height = y + .9 * c.cropBottom / c.w;
    return "--piece-h:" + height + ";--photo-x:" + (x * 100) + "%;--photo-y:" + (y / height * 100)
      + "%;--hanger-w:" + (c.hanger * 100) + "%;--hanger-x:" + ((1 - c.hanger) * 50) + "%;--hanger-top:" + (.22 - c.hanger / 12) + ";";
  }
  function cancelFlight(){ if (flight) { flight.cancel(); flight = null; } }

  var once = T.ticker.map(function(t){ return '<span class="gbr-ticker-item">' + esc(t) + '</span><span class="gbr-ticker-dot">✦</span>'; }).join("");
  $(".gbr-ticker-run").innerHTML = once + once + once + once;

  function swayStyle(i){
    /* every piece moves a little differently, like real clothes on a rail */
    var d = (6 + ((i * 37) % 23) / 10).toFixed(1), delay = -((i * 53) % 40) / 10, tilt = (0.4 + ((i * 29) % 6) / 10).toFixed(1);
    return "--sway-d:" + d + "s;--sway-delay:" + delay + "s;--tilt:" + tilt + "deg";
  }

  /* while loading: empty hangers on the rail */
  var skel = "";
  for (var i = 0; i < Math.min(LIMIT, CUTS.length); i++) skel += '<li class="gbr-item is-loading" style="' + swayStyle(i) + '"><span class="gbr-pick"><span class="gbr-piece"><span class="gbr-hanger"></span></span></span></li>';
  ui.list.innerHTML = skel;
  root.style.setProperty("--n", Math.min(LIMIT, CUTS.length));

  /* ── start only when the customer scrolls near the rail (keeps the homepage fast);
        the hangers stop swaying while the rail is off screen ── */
  var started = false;
  function start(){ if (started) return; started = true; load(); }
  if (window.IntersectionObserver) {
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) start();
        root.classList.toggle("is-paused", !e.isIntersecting);
      });
    }, { rootMargin: "700px 0px" }).observe(root);
  } else start();

  function loadProducts(){
    var key = "gbr_catalog_" + HANDLE + (AR ? "_ar" : "");
    try { var cached = JSON.parse(sessionStorage.getItem(key)); if (cached && Date.now() - cached.at < 180000) return Promise.resolve(cached.data); } catch(e){}
    var ctrl = window.AbortController ? new AbortController() : null, timer = setTimeout(function(){ if (ctrl) ctrl.abort(); }, 12000);
    return fetch(STORE + (AR ? "/ar" : "") + "/collections/" + HANDLE + "/products.json?limit=250", ctrl ? { credentials: "omit", signal: ctrl.signal } : { credentials: "omit" })
      .then(function(r){ if (!r.ok) throw new Error("Catalogue HTTP " + r.status); return r.json(); })
      .then(function(data){
        clearTimeout(timer);
        if (!data || !Array.isArray(data.products)) throw new Error("Invalid catalogue");
        try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data: { products: data.products } })); } catch(e){}
        return data;
      }, function(err){ clearTimeout(timer); throw err; });
  }
  function load(){
    loadProducts().then(function(data){
      var byHandle = {};
      data.products.forEach(function(p){ byHandle[p.handle] = p; });
      /* only pieces that still exist, have a photo and are in stock */
      items = CUTS.map(function(c){ var p = byHandle[c.handle]; return p && p.images && p.images.length && p.variants.some(function(v){ return v.available; }) ? { c: c, p: p } : null; })
                  .filter(Boolean).slice(0, LIMIT);
      if (!items.length) throw new Error("no pieces in stock");
      renderRail();
    }).catch(function(err){
      /* nothing to hang: hide only the rail; the heading and "Shop the Collection" stay */
      if (window.console) console.warn("Christmas rail:", err && err.message);
      root.classList.add("is-empty");
    });
  }

  function priceOf(p){ var v = p.variants.filter(function(v){ return v.available; })[0] || p.variants[0]; return +v.price; }
  function labelOf(it){ return (AR ? it.c.ar : it.c.en) || it.p.title; }
  function detailOf(it){ return (AR ? it.c.d_ar : it.c.d_en) || ""; }

  function renderRail(){
    root.style.setProperty("--n", items.length);
    root.style.setProperty("--rail-ratio", Math.max.apply(null, items.map(function(it){ var c = it.c; return .49 + .9 * (c.cropBottom || c.h) / c.w - .9 * c.neckY * c.h / c.w; })));
    ui.list.innerHTML = items.map(function(it, i){
      var p = it.p, price = T.price(priceOf(p));
      return '<li class="gbr-item" data-i="' + i + '" style="' + swayStyle(i) + '">'
        + '<button type="button" class="gbr-pick" aria-label="' + esc(T.open.replace("{name}", p.title).replace("{price}", price)) + '">'
        + '<span class="gbr-piece' + (it.c.cropBottom ? " is-cropped" : "") + '" style="' + placement(it.c, true) + '"><span class="gbr-hanger" aria-hidden="true">' + hangerLogo + '</span>'
        + '<img src="' + esc(railSrc(it.c)) + '" loading="' + (i < 3 ? "eager" : "lazy") + '" decoding="async" width="' + it.c.w + '" height="' + it.c.h + '" alt="' + esc(p.title) + '" draggable="false"></span>'
        + '<span class="gbr-label"><bdi class="gbr-label-name">' + esc(labelOf(it)) + '</bdi><span class="gbr-label-detail">' + esc(detailOf(it)) + '</span><bdi class="gbr-label-price">' + esc(price) + '</bdi></span>'
        + "</button></li>";
    }).join("");
    $(".gbr-count").textContent = T.count.replace("{n}", items.length);
    root.classList.add("is-ready");
    requestAnimationFrame(updateBrowse);
  }

  function updateBrowse(){
    var max = ui.scroll.scrollWidth - ui.scroll.clientWidth, pos = Math.abs(ui.scroll.scrollLeft);
    $(".gbr-browse").classList.toggle("is-static", max < 3);
    root.classList.toggle("is-scrollable", max >= 3);
    $(".gbr-rail-prev").disabled = pos < 3;
    $(".gbr-rail-next").disabled = pos >= max - 3;
  }
  function browse(dir){
    ui.scroll.scrollBy({ left: dir * (AR ? -1 : 1) * Math.max(180, ui.scroll.clientWidth * .7), behavior: REDUCED ? "auto" : "smooth" });
  }
  $(".gbr-rail-prev").addEventListener("click", function(){ browse(-1); });
  $(".gbr-rail-next").addEventListener("click", function(){ browse(1); });
  ui.scroll.addEventListener("scroll", updateBrowse, { passive: true });
  window.addEventListener("resize", function(){
    updateBrowse();
    if (!ui.focus.hidden && !closing) growTo(Math.max(railH(), ui.focus.offsetHeight));
  });

  /* ── wave: scrolling the page (or swiping the rail) gives the hangers a push. Each piece swings
        on its hook like a pendulum and slowly settles; the push reaches the pieces one after the
        other, so the rail moves like a wave. Only while the rail is on screen; off for reduced motion. ── */
  var swing = [], swinging = false;
  function push(force){
    if (REDUCED || !items.length || !ui.focus.hidden || Math.abs(force) < .05) return;
    force = Math.max(-.8, Math.min(.8, force));
    var picks = ui.list.querySelectorAll(".gbr-pick"), now = performance.now(), order;
    for (var i = 0; i < picks.length; i++) {
      var s = swing[i] || (swing[i] = { a: 0, v: 0, q: [] });
      s.el = picks[i];
      order = AR ? picks.length - 1 - i : i;   /* the wave runs in reading direction */
      s.q.push({ at: now + order * 75, f: force * (.85 + ((i * 37) % 7) / 20) });
    }
    if (!swinging) { swinging = true; ui.list.classList.add("is-swinging"); requestAnimationFrame(tick); }
  }
  function tick(now){
    var moving = false;
    swing.forEach(function(s){
      while (s.q.length && s.q[0].at <= now) s.v += s.q.shift().f;
      s.v = (s.v - s.a * .06) * .92;                /* spring back to hanging straight, with friction (settles in about a second) */
      s.a = Math.max(-5, Math.min(5, s.a + s.v));   /* never more than 5 degrees (owner: "too wavy") */
      if (s.q.length || Math.abs(s.a) > .03 || Math.abs(s.v) > .03) moving = true;
      s.el.style.setProperty("--wind", s.a.toFixed(2) + "deg");
    });
    if (moving) { requestAnimationFrame(tick); return; }
    swinging = false; ui.list.classList.remove("is-swinging");
    swing.forEach(function(s){ s.a = s.v = 0; s.el.style.removeProperty("--wind"); });
  }
  function onScreen(){ var r = ui.scroll.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight; }
  var lastY = window.pageYOffset, lastX = 0, accY = 0, accX = 0, flushTimer = null;
  function collect(){
    if (flushTimer) return;
    flushTimer = setTimeout(function(){
      flushTimer = null;
      if (onScreen()) push(-accY * .004 - accX * .008);
      accY = accX = 0;
    }, 80);
  }
  window.addEventListener("scroll", function(){
    var y = window.pageYOffset; accY += y - lastY; lastY = y; collect();
  }, { passive: true });
  ui.scroll.addEventListener("scroll", function(){
    var x = ui.scroll.scrollLeft; accX += x - lastX; lastX = x; collect();
  }, { passive: true });

  /* drag the rail with the mouse (only when it is longer than the box); phones swipe natively */
  var down = null;
  ui.scroll.addEventListener("pointerdown", function(e){
    if (e.pointerType !== "mouse" || e.button !== 0 || ui.scroll.scrollWidth <= ui.scroll.clientWidth) return;
    down = { x: e.clientX, left: ui.scroll.scrollLeft }; dragMoved = false;
  });
  window.addEventListener("pointermove", function(e){
    if (!down) return;
    var dx = e.clientX - down.x;
    if (Math.abs(dx) > 6) { dragMoved = true; ui.scroll.classList.add("is-dragging"); }
    if (dragMoved) ui.scroll.scrollLeft = down.left - dx;
  });
  window.addEventListener("pointerup", function(){
    if (!down) return;
    down = null; ui.scroll.classList.remove("is-dragging");
    setTimeout(function(){ dragMoved = false; }, 0);
  });

  /* One hover zone for the whole rail, using the unchanged layout positions, so the
     neighbours sliding aside can't make the hover flicker (guide: "stable hover"). */
  function highlight(index){
    ui.list.classList.toggle("has-active", index >= 0);
    ui.list.querySelectorAll(".gbr-item[data-i]").forEach(function(li, i){
      li.classList.toggle("is-active", i === index);
      li.style.setProperty("--aside", index < 0 || i === index ? "0px" : ((i < index ? -1 : 1) * (AR ? -1 : 1) * 12) + "px");
    });
  }
  ui.scroll.addEventListener("pointermove", function(e){
    if (e.pointerType !== "mouse" || touch || down || !ui.focus.hidden || !items.length) return;
    var x = e.clientX - ui.list.getBoundingClientRect().left, nearest = -1, distance = Infinity;
    ui.list.querySelectorAll(".gbr-item[data-i]").forEach(function(li, i){
      var d = Math.abs(x - (li.offsetLeft + li.offsetWidth / 2)); if (d < distance) { distance = d; nearest = i; }
    });
    highlight(nearest);
  });
  ui.scroll.addEventListener("pointerleave", function(){ highlight(-1); });
  ui.list.addEventListener("focusin", function(e){ var li = e.target.closest(".gbr-item[data-i]"); if (li) highlight(+li.getAttribute("data-i")); });
  ui.list.addEventListener("focusout", function(e){ if (!ui.list.contains(e.relatedTarget)) highlight(-1); });

  /* finger wobble under 10px is a tap, more is a swipe (guide: touch tuning) */
  var tapStart = null, touchMoved = false, suppressClickUntil = 0;
  ui.scroll.addEventListener("pointerdown", function(e){ if (e.pointerType !== "mouse") { tapStart = { x: e.clientX, y: e.clientY }; touchMoved = false; suppressClickUntil = 0; } }, { passive: true });
  ui.scroll.addEventListener("pointermove", function(e){ if (tapStart && Math.hypot(e.clientX - tapStart.x, e.clientY - tapStart.y) > 10) touchMoved = true; }, { passive: true });
  ui.scroll.addEventListener("pointercancel", function(){ touchMoved = true; tapStart = null; suppressClickUntil = Date.now() + 400; });
  ui.scroll.addEventListener("pointerup", function(){ tapStart = null; if (touchMoved) suppressClickUntil = Date.now() + 400; setTimeout(function(){ touchMoved = false; }, 0); });

  ui.list.addEventListener("click", function(e){
    if (dragMoved || touchMoved || Date.now() < suppressClickUntil) { e.preventDefault(); return; }
    var li = e.target.closest(".gbr-item[data-i]");
    if (li) openFocus(+li.getAttribute("data-i"));
  });

  /* ── live stock of one product (the same JSON the cart checks before payment) ── */
  function loadStock(it){
    var h = it.p.handle;
    if (stock[h]) return stock[h];
    stock[h] = fetch(STORE + "/products/" + encodeURIComponent(h) + "?view=gb-stock", { credentials: "same-origin" })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(d){
        var map = {};
        (d.variants || []).forEach(function(v){ map[String(v.id)] = v.m === "shopify" && v.p === "deny" ? Math.max(0, parseInt(v.q, 10) || 0) : null; });
        return map;
      })
      .catch(function(){ return {}; });   /* unknown: the cart checks again before payment */
    return stock[h];
  }
  function stockNow(vid){ var it = items[cur]; return it && it.stock ? it.stock[String(vid)] : undefined; }
  function inCart(vid){ return window.GBCart ? GBCart.usedQty(String(vid)) : 0; }

  /* ═════════ close-up ═════════ */
  function itemEl(i){ return ui.list.querySelector('.gbr-item[data-i="' + i + '"]'); }

  function fill(i){
    var it = items[i], p = it.p;
    cur = i; chosen = null;
    cancelFlight();
    ui.piece.style.cssText = placement(it.c, false);
    ui.fImg.src = railSrc(it.c);              /* the small photo first (already loaded), then the sharp one */
    ui.fImg.width = it.c.w; ui.fImg.height = it.c.h;
    var sharp = new Image(); sharp.src = detailSrc(it.c);
    sharp.decode ? sharp.decode().then(function(){ if (cur === i) ui.fImg.src = sharp.src; }, function(){}) : (sharp.onload = function(){ if (cur === i) ui.fImg.src = sharp.src; });
    ui.fImg.alt = p.title;
    ui.name.textContent = p.title;
    ui.detail.textContent = detailOf(it);
    ui.position.textContent = (i + 1) + " / " + items.length;
    ui.thumbs.innerHTML = (p.images || []).map(function(photo, n){ return '<button type="button" data-photo="' + n + '" aria-label="' + esc(T.photo_n.replace("{n}", n + 1)) + '" aria-pressed="' + (n === 0) + '"><img src="' + esc(img(photo.src, 100)) + '" alt="" loading="lazy" width="44" height="54"></button>'; }).join("");
    showPhoto(false);
    drawSizes();
    if (!it.stock) loadStock(it).then(function(map){ it.stock = map; if (cur === i) drawSizes(true); });
  }

  /* sizes as kraft tags; picks the size by itself when only one is in stock */
  function drawSizes(keep){
    var it = items[cur], p = it.p, was = keep && chosen ? String(chosen.id) : null;
    var open = p.variants.filter(function(v){ return v.available && !(stockNow(v.id) != null && stockNow(v.id) <= 0); });
    ui.sizes.innerHTML = p.variants.map(function(v){
      var s = sizeParts(v.option1 || v.title), ok = open.indexOf(v) > -1;
      return '<button type="button" class="gbr-size" data-v="' + v.id + '"' + (ok ? "" : " disabled") + ' aria-pressed="false" aria-label="' + esc(s.full + (ok ? "" : " · " + T.sold)) + '">'
        + '<span class="gbr-size-str"></span><span class="gbr-size-tag"><b dir="ltr">' + esc(s.a) + "</b>" + (s.b ? "<small>" + esc(s.b) + "</small>" : "") + "</span></button>";
    }).join("");
    chosen = null;
    if (was && open.some(function(v){ return String(v.id) === was; })) choose(was);
    else if (open.length === 1) choose(open[0].id);
    else { ui.price.textContent = T.price(priceOf(p)); setAdd(); }
  }

  function showPhoto(on){
    if (cur < 0) return;
    if (on) selectPhoto(0);
    ui.hang.hidden = !!on; ui.photo.hidden = !on;
    ui.thumbs.hidden = !on;
    ui.photoBtn.textContent = on ? T.rail_view : T.photo;
    ui.photoBtn.setAttribute("aria-pressed", on ? "true" : "false");
    if (!ui.focus.hidden) growTo(Math.max(railH(), ui.focus.offsetHeight));
  }
  ui.photoBtn.addEventListener("click", function(){ showPhoto(ui.photo.hidden); });
  function selectPhoto(n){
    var p = items[cur].p, photo = p.images[n]; if (!photo) return;
    ui.photoImg.src = img(photo.src, 900); ui.photoImg.alt = p.title + " — " + T.photo_n.replace("{n}", n + 1);
    ui.thumbs.querySelectorAll("button").forEach(function(b){ b.setAttribute("aria-pressed", +b.getAttribute("data-photo") === n ? "true" : "false"); });
  }
  ui.thumbs.addEventListener("click", function(e){ var b = e.target.closest("button[data-photo]"); if (b) selectPhoto(+b.getAttribute("data-photo")); });

  function choose(vid){
    var p = items[cur].p;
    chosen = p.variants.filter(function(v){ return String(v.id) === String(vid); })[0] || null;
    ui.sizes.querySelectorAll(".gbr-size").forEach(function(b){
      var on = chosen && b.getAttribute("data-v") === String(chosen.id);
      b.classList.toggle("is-on", !!on); b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    ui.price.textContent = T.price(chosen ? chosen.price : priceOf(p));
    setAdd();
  }
  /* the button: Add to cart / In your cart / all stock already in the cart (no "Only N left": owner, 2026-10-24) */
  function setAdd(){
    var vid = chosen && String(chosen.id), done = false, full = false, hint = "";
    if (vid && window.GBCart) {
      var saved = GBCart.pieceMap()[vid], s = stockNow(vid);
      done = !!(saved && saved.quantity > 0);
      full = s != null && s > 0 && inCart(vid) >= s && !done;
      if (full) hint = T.all_in;
    }
    if (!hint && chosen && items[cur].p.variants.length === 1) hint = T.one_size.replace("{s}", sizeParts(chosen.option1 || chosen.title).full);
    ui.add.classList.toggle("is-done", done);
    ui.add.textContent = done ? T.added : T.add;
    ui.add.disabled = full;
    ui.add.setAttribute("aria-disabled", !chosen && !done ? "true" : "false");
    ui.hint.classList.remove("is-warn");
    ui.hint.innerHTML = hint ? esc(hint) : "&nbsp;";
  }

  function growTo(h){ ui.stage.style.height = h + "px"; }
  if (window.ResizeObserver) new ResizeObserver(function(){
    if (!ui.focus.hidden && !closing) {
      var height = Math.max(railH(), ui.focus.offsetHeight);
      if (Math.abs(ui.stage.offsetHeight - height) > 1) growTo(height);
    }
  }).observe(ui.focus);
  function railH(){ return ui.scroll.offsetHeight + ui.under.offsetHeight; }

  function openFocus(i){
    var li = itemEl(i);
    if (!li || closing || !ui.focus.hidden) return;
    highlight(-1);
    ui.scroll.inert = true; ui.under.inert = true;
    ui.stage.style.height = ui.stage.offsetHeight + "px";
    var from = li.querySelector(".gbr-piece").getBoundingClientRect();
    fill(i);
    ui.focus.hidden = false;
    ui.focus.classList.add("is-entering");
    root.classList.add("is-focus");
    li.classList.add("is-lifted");
    growTo(Math.max(railH(), ui.focus.offsetHeight));
    fly(from, false);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ ui.focus.classList.remove("is-entering"); }); });
    ui.name.focus({ preventScroll: true });
    var top = ui.stage.getBoundingClientRect().top;
    if (ui.focus.getBoundingClientRect().bottom > innerHeight - 12 || top < 60) ui.stage.scrollIntoView({ behavior: REDUCED ? "auto" : "smooth", block: "start" });
  }

  /* the piece is lifted off the rail into the close-up (and hung back) */
  function fly(rect, back, done){
    cancelFlight();
    if (REDUCED || !rect.width) { if (done) done(); return; }
    var to = ui.piece.getBoundingClientRect();
    var t = "translate(" + (rect.left - to.left) + "px," + (rect.top - to.top) + "px) scale(" + rect.width / to.width + ")";
    flight = ui.piece.animate(back ? [{ transform: "none" }, { transform: t }] : [{ transform: t }, { transform: "none" }],
      { duration: 420, easing: "cubic-bezier(.25,.9,.3,1)", fill: "none" });
    flight.onfinish = function(){ flight = null; if (done) done(); };
  }

  function closeFocus(){
    if (cur < 0 || ui.focus.hidden || closing) return;
    showPhoto(false);
    closing = true; cancelFlight();
    ui.focus.classList.add("is-closing", "is-entering");
    var li = itemEl(cur);
    var finish = function(){
      ui.focus.hidden = true;
      closing = false; ui.focus.classList.remove("is-closing");
      ui.scroll.inert = false; ui.under.inert = false;
      root.classList.remove("is-focus");
      if (li) li.classList.remove("is-lifted");
      ui.stage.style.height = "";
      var btn = li && li.querySelector(".gbr-pick");
      if (btn) btn.focus({ preventScroll: true });
      cur = -1;
    };
    if (li) fly(li.querySelector(".gbr-piece").getBoundingClientRect(), true, finish);
    else finish();
  }

  /* carousel step: the new piece comes in from the side you are heading to */
  function step(dir){
    if (cur < 0 || closing) return;
    var n = (cur + dir + items.length) % items.length;
    var old = itemEl(cur), nu = itemEl(n);
    if (old) old.classList.remove("is-lifted");
    if (nu) {
      nu.classList.add("is-lifted");
      /* move the blurred rail along, so closing puts the piece back in view */
      var r = nu.getBoundingClientRect(), s = ui.scroll.getBoundingClientRect();
      ui.scroll.scrollBy({ left: r.left + r.width / 2 - (s.left + s.width / 2), behavior: REDUCED ? "auto" : "smooth" });
    }
    fill(n);
    ui.main.style.setProperty("--swap-dir", (AR ? -dir : dir));
    ui.main.classList.remove("is-swap"); void ui.main.offsetWidth;
    if (!REDUCED) ui.main.classList.add("is-swap");
    growTo(Math.max(railH(), ui.focus.offsetHeight));
  }

  $(".gbr-close").addEventListener("click", closeFocus);
  $(".gbr-nav-prev").addEventListener("click", function(){ step(-1); });
  $(".gbr-nav-next").addEventListener("click", function(){ step(1); });
  ui.sizes.addEventListener("click", function(e){ var b = e.target.closest(".gbr-size"); if (b && !b.disabled) choose(b.getAttribute("data-v")); });
  /* keep keyboard focus inside the close-up while the rail behind it is inactive */
  ui.focus.addEventListener("keydown", function(e){
    if (e.key !== "Tab") return;
    var buttons = Array.prototype.filter.call(ui.focus.querySelectorAll("button:not([disabled])"), function(b){ return b.getClientRects().length; });
    if (!buttons.length) return;
    var first = buttons[0], last = buttons[buttons.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === ui.name)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  /* tapping the empty space around the close-up closes it */
  ui.focus.addEventListener("click", function(e){ if (e.target === ui.focus) closeFocus(); });

  document.addEventListener("keydown", function(e){
    if (ui.focus.hidden) return;
    var cart = document.getElementById("gb-cart");
    if (cart && !cart.hidden) return;
    if (e.key === "Escape") closeFocus();
    else if (e.key === "ArrowRight" && !e.target.closest(".gbr-sizes, .gbr-photo-thumbs")) { e.preventDefault(); step(AR ? -1 : 1); }
    else if (e.key === "ArrowLeft" && !e.target.closest(".gbr-sizes, .gbr-photo-thumbs")) { e.preventDefault(); step(AR ? 1 : -1); }
  });

  /* swipe the close-up on phones */
  var sx = null, sy = null;
  ui.focus.addEventListener("touchstart", function(e){
    sx = null;
    if (e.touches.length !== 1 || e.target.closest("button, .gbr-photo-thumbs")) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  ui.focus.addEventListener("touchcancel", function(){ sx = null; }, { passive: true });
  ui.focus.addEventListener("touchend", function(e){
    if (sx == null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    sx = null;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) step((dx < 0 ? 1 : -1) * (AR ? -1 : 1));
  }, { passive: true });

  /* ── Add to cart: a single piece in the shared cart (same line as the Christmas page makes) ── */
  function cartTarget(){
    var list = document.querySelectorAll(".gb-cart-float, .gb-cart-dock");
    for (var k = 0; k < list.length; k++) {
      var r = list[k].getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < innerHeight && getComputedStyle(list[k]).visibility !== "hidden" && getComputedStyle(list[k]).opacity !== "0") return list[k];
    }
    return null;
  }
  /* the photo flies to the cart button in an arc, then the button bounces (guide: 850 ms) */
  function cartFeedback(){
    var target = cartTarget(), source = ui.photo.hidden ? ui.fImg : ui.photoImg;
    if (!target || REDUCED) return;
    var from = source.getBoundingClientRect(), to = target.getBoundingClientRect();
    if (!from.width) return;
    var ghost = document.createElement("img");
    ghost.src = source.currentSrc || source.src; ghost.className = "gbr-cart-flight"; ghost.alt = ""; ghost.setAttribute("aria-hidden", "true");
    ghost.style.cssText = "left:" + from.left + "px;top:" + from.top + "px;width:" + from.width + "px;height:" + from.height + "px";
    document.body.appendChild(ghost);
    var dx = to.left + to.width / 2 - from.left - from.width / 2, dy = to.top + to.height / 2 - from.top - from.height / 2;
    var lift = Math.min(120, Math.max(0, from.top - to.top - 20)) * -.35;   /* a gentle arc, never above the button */
    var anim = ghost.animate([
      { transform: "translate(0,0) scale(1)", opacity: .9 },
      { transform: "translate(" + (dx * .5) + "px," + (dy * .45 + lift) + "px) scale(.42)", opacity: .8, offset: .55 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(.06)", opacity: 0 }
    ], { duration: 850, easing: "cubic-bezier(.45,0,.25,1)" });
    /* "scale" (not "transform"), so the button keeps its own position transform while it bounces */
    anim.onfinish = function(){ ghost.remove(); target.animate([{ scale: "1" }, { scale: "1.14" }, { scale: "1" }], { duration: 280, easing: "ease-out" }); };
    anim.oncancel = function(){ ghost.remove(); };
  }
  function needSize(){
    ui.hint.textContent = T.choose; ui.hint.classList.add("is-warn");
    ui.sizes.classList.remove("is-shake"); void ui.sizes.offsetWidth;
    if (!REDUCED) ui.sizes.classList.add("is-shake");
  }
  ui.add.addEventListener("click", function(){
    if (ui.add.classList.contains("is-done")) { if (window.GBCart) GBCart.open(); return; }
    var it = items[cur], p = it && it.p;
    if (!p || !chosen) { needSize(); return; }
    if (!window.GBCart || closing) return;
    var map = GBCart.pieceMap(), vid = String(chosen.id), have = map[vid], s = stockNow(vid);
    if (s != null && inCart(vid) >= s) { setAdd(); return; }
    map[vid] = {
      catKey: "c0", catName: T.cart_cat,
      variantId: vid, productId: String(p.id), handle: p.handle, name: p.title,
      size: chosen.option1 || chosen.title, price: +chosen.price,   /* the shop's own size name, like the other pages */
      img: img(p.images[0].src, 300), quantity: (have ? have.quantity : 0) + 1, maxQty: s != null ? s : 999,
      stock: s != null ? s : GBCart.stockOf(vid), src: "xmas", url: ALL_URL
    };
    GBCart.syncPieces(map);
    cartFeedback();
    setAdd();
  });
  if (window.GBCart) GBCart.onChange(function(){ if (cur >= 0) setAdd(); });
})();
